module.exports = __webpack_public_path__ + "static/media/fundo.75307a54.png";